import { React, useState, useRef, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import IconButton from "@mui/material/IconButton";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Button from "@mui/material/Button";
import { ToastContainer, toast } from "react-toastify";
import { Dropdown } from "semantic-ui-react";
import Tooltip from "@mui/material/Tooltip";
import { Stack } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import Papa from "papaparse";
import MDBadge from "components/MDBadge";
import MDTypography from "components/MDTypography";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DescriptionIcon from "@mui/icons-material/Description";
import VisibilityIcon from "@mui/icons-material/Visibility";
import colors from "assets/theme/base/colors";
import "../campus/Campus.css";
import Select from "react-select";
import InputMask from "react-input-mask";
import Typography from "@mui/material/Typography";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import step from "assets/theme/components/stepper/step";
const { info } = colors;
const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");
const BasicInfoCorrection = () => {
  const [campaignId, setCampaignId] = useState(null);
  const [form_no, setFormNo] = useState("");
  const [applicant_cnic, setApplicantCnic] = useState("");
  const [all_campaigns, setAllCampaigns] = useState([]);
  const [application_type, setApplicationType] = useState("");
  // const [application, setApplication] = useState({});
  const [showFields, setShowFields] = useState(false);
  const [applicationId, setApplicationId] = useState(null);
  const [cnic, setCnic] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [name, setName] = useState("");
  const [fatherName, setFatherName] = useState("");
  const [fatherOccupation, setFatherOccupation] = useState("");
  const [fatherIncome, setFatherIncome] = useState("");
  const [fatherCnic, setFatherCnic] = useState("");
  const [bzuRegistration, setBzuRegistration] = useState("");
  const [gender, setGender] = useState("");
  const [nationality, setNationality] = useState("");
  const [province, setProvince] = useState("");
  const [provincesList, setProvincesList] = useState([]);
  const [domicile, setDomicile] = useState("");
  const [isDisabled, setIsDisabled] = useState("no");
  const [citiesList, setCitiesList] = useState([]);
  const [religion, setReligion] = useState("");
  const [currentAddress, setCurrentAddress] = useState("");
  const [permanentAddress, setPermanentAddress] = useState("");
  const [telNo, setTelNo] = useState("");
  const [fatherCellNo, setFatherCellNo] = useState("");
  const [applicantCellNo, setApplicantCellNo] = useState("");
  const [placeOfStay, setPlaceOfStay] = useState("");
  const [hafizQuran, setHafizQuran] = useState(""); // Boolean default
  const [needTransport, setNeedTransport] = useState("");
  const [disability, setDisability] = useState("");
  const [documentType, setDocumentType] = useState("cnic");
  const [applicantImage, setApplicantImage] = useState("");
  const [applicantCnicFront, setApplicantCnicFront] = useState("");
  const [applicantCnicBack, setApplicantCnicBack] = useState("");
  const [fatherCnicFront, setFatherCnicFront] = useState("");
  const [fatherCnicBack, setFatherCnicBack] = useState("");
  const [emergencyContactName, setEmergencyContactName] = useState("");
  const [emergencyContactCellNo, setEmergencyContactCellNo] = useState("");
  const [emergencyContactAddress, setEmergencyContactAddress] = useState("");
  const [tempImage, setTempImage] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [cropper, setCropper] = useState(null);
  const [currentField, setCurrentField] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const fileInputRefs = {
    applicantImage: useRef(null),
    applicantCnicFront: useRef(null),
    applicantCnicBack: useRef(null),
    fatherCnicFront: useRef(null),
    fatherCnicBack: useRef(null),
  };
  const handlePlaceholderClick = (field) => {
    fileInputRefs[field].current.click();
  };
  const cropImage = () => {
    if (cropper) {
      const croppedImage = cropper.getCroppedCanvas().toDataURL();
      switch (currentField) {
        case "applicantImage":
          setApplicantImage(croppedImage);
          break;
        case "applicantCnicFront":
          setApplicantCnicFront(croppedImage);
          break;
        case "applicantCnicBack":
          setApplicantCnicBack(croppedImage);
          break;
        case "fatherCnicFront":
          setFatherCnicFront(croppedImage);
          break;
        case "fatherCnicBack":
          setFatherCnicBack(croppedImage);
          break;
        default:
          break;
      }
      setOpenDialog(false);
    }
  };
  const handleImageChange = (e, field) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setTempImage(reader.result);
        setCurrentField(field);
        setOpenDialog(true);
      };
      reader.readAsDataURL(file);
    }
  };
  const getSixteenYearsBack = () => {
    const today = new Date();
    today.setFullYear(today.getFullYear() - 16);
    return today.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };
  const handleCampaignChange = (selected) => {
    setCampaignId(selected ? selected.value : null);
  };
  const fetchAllCampaigns = async () => {
    try {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await fetch(
        BASE_URL + `/campaign/get_campaigns`,
        requestOptions
      );
      const data = await response.json();
      setAllCampaigns(data.campaigns);
    } catch (error) {
      console.log("Error fetching campaigns:", error);
    }
  };
  const fetchApplication = async () => {
    if (!campaignId) {
      toast.error("Please select a campaign.");
    }
    try {
      let payload = {
        campaign_id: campaignId,
        applicant_cnic: applicant_cnic,
        application_id: form_no,
      };
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      };
      const response = await fetch(
        BASE_URL + `/submit_application/get_application_by_cnic_or_id`,
        requestOptions
      );
      const data = await response.json();
      // setApplication(data.application);
      let application = data.application;
      setApplicationId(application.id);
      setApplicationType(application.application_type);
      setCnic(application.applicant_cnic);
      setName(application.name);
      setApplicantImage(application.applicant_image);
      setApplicantCnicFront(application.applicant_cnic_front);
      setApplicantCnicBack(application.applicant_cnic_back);
      if (
        application.applicant_cnic_back == null ||
        application.applicant_cnic_back == ""
      ) {
        setDocumentType("bform");
      }
      setDateOfBirth(application.dob);
      setFatherName(application.father_name);
      setFatherOccupation(application.father_occupation);
      setFatherIncome(application.father_income);
      setFatherCnic(application.father_cnic);
      setFatherCnicFront(application.father_cnic_front);
      setFatherCnicBack(application.father_cnic_back);
      setBzuRegistration(application.bzu_registration);
      setGender(application.gender);
      setNationality(application.nationality);
      setProvince(application.province);
      setDomicile(application.domicile);
      setReligion(application.religion);
      setCurrentAddress(application.current_address);
      setPermanentAddress(application.permanent_address);
      setTelNo(application.tel_no);
      setFatherCellNo(application.father_phone);
      setApplicantCellNo(application.applicant_phone);
      setPlaceOfStay(application.place_of_stay);
      setHafizQuran(application.hafiz_quran == 'True' ? "Yes" : "No");
      setNeedTransport(application.need_transport);
      setDisability(application.disability);
      setEmergencyContactName(application.emergency_contact_name);
      setEmergencyContactCellNo(application.emergency_contact_no);
      setEmergencyContactAddress(application.emergency_contact_address);
      // setShowFields(true);
    } catch (error) {
      console.log("Error fetching application:", error);
    }
  };
  const validateStep1 = () => {
      let errors = {};
  
      // Helper to safely handle undefined values
      const safeValue = (value) => (value || "").toString();
  
      // Validate CNIC
      if (!safeValue(cnic)) {
        errors.cnic = "CNIC is required.";
      }
  
      // Validate Name
      if (!safeValue(name)) {
        errors.name = "Name is required.";
      }
  
      // Validate Date of Birth
      if (!safeValue(dateOfBirth)) {
        errors.dateOfBirth = "Date of Birth is required.";
      }
  
      // Validate Father Name
      if (!safeValue(fatherName)) {
        errors.fatherName = "Father Name is required.";
      }
  
      // Validate Father Occupation
      if (!safeValue(fatherOccupation)) {
        errors.fatherOccupation = "Father/Guardian Occupation is required.";
      }
      // Validate Father CNIC
      if (!safeValue(fatherCnic)) {
        errors.fatherCnic = "Father/Guardian CNIC is required.";
      }
  
      // Validate Gender
      if (!safeValue(gender)) {
        errors.gender = "Gender is required.";
      }
  
      // Validate Nationality
      if (!safeValue(nationality)) {
        errors.nationality = "Nationality is required.";
      }
  
      // Validate Province
      if (!safeValue(province)) {
        errors.province = "Province is required.";
      }
  
      // Validate Domicile
      if (!safeValue(domicile)) {
        errors.domicile = "Domicile is required.";
      }
  
      // Validate Religion
      if (!safeValue(religion)) {
        errors.religion = "Religion is required.";
      }
  
      // Validate Current Address
      if (!safeValue(currentAddress)) {
        errors.currentAddress = "Current Address is required.";
      }
  
      // Validate Permanent Address
      if (!safeValue(permanentAddress)) {
        errors.permanentAddress = "Permanent Address is required.";
      }
  
      // Validate Father Cell Number
      if (!safeValue(fatherCellNo)) {
        errors.fatherCellNo = "Father/Guardian Cell Number is required.";
      }
  
      // Validate Applicant Cell Number
      if (!safeValue(applicantCellNo)) {
        errors.applicantCellNo = "Applicant Cell Number is required.";
      }
  
      // Validate Place of Stay
      if (!safeValue(placeOfStay)) {
        errors.placeOfStay = "Place of Stay is required.";
      }
  
      // Validate Hafiz Quran
      if (!safeValue(hafizQuran)) {
        errors.hafizQuran = "Hafiz e Quran selection is required.";
      }
  
      // Validate Emergency Contact Name
      if (!safeValue(emergencyContactName)) {
        errors.emergencyContactName = "Emergency Contact Name is required.";
      }
  
      // Validate Emergency Contact Cell Number
      if (!safeValue(emergencyContactCellNo)) {
        errors.emergencyContactCellNo =
          "Emergency Contact Cell Number is required.";
      }
  
      // Validate Emergency Contact Address
      if (!safeValue(emergencyContactAddress)) {
        errors.emergencyContactAddress = "Emergency Contact Address is required.";
      }
  
      // Validate Applicant Image
      if (!safeValue(applicantImage)) {
        errors.applicantImage = "Applicant Image is required.";
      }
      if (!safeValue(applicantCnicFront)) {
        errors.applicantCnicFront = "Applicant CNIC Front is required.";
      }
      if (documentType == "cnic") {
        if (!safeValue(applicantCnicBack)) {
          errors.applicantCnicBack = "Applicant CNIC Back is required.";
        }
      }
  
      setFormErrors(errors);
  
      return Object.keys(errors).length === 0; // Return true if no errors
    };
    const submitStep1 = async () => {
      if (!validateStep1()) {
        return;
      }
      let data = {
        step : 1,
        application_id: applicationId,
        cnic,
        date_of_birth: dateOfBirth,
        name,
        father_name: fatherName,
        father_occupation: fatherOccupation,
        father_income: fatherIncome,
        father_cnic: fatherCnic,
        bzu_registration: bzuRegistration,
        gender,
        nationality,
        province,
        domicile,
        religion,
        current_address: currentAddress,
        permanent_address: permanentAddress,
        tel_no: telNo,
        father_cell_no: fatherCellNo,
        applicant_cell_no: applicantCellNo,
        place_of_stay: placeOfStay,
        hafiz_quran: hafizQuran === "Yes", // Convert to boolean
        need_transport: needTransport,
        disability: disability,
        applicant_image: applicantImage,
        applicant_cnic_front: applicantCnicFront,
        applicant_cnic_back: applicantCnicBack,
        father_cnic_front: fatherCnicFront,
        father_cnic_back: fatherCnicBack,
        emergency_contact_name: emergencyContactName,
        emergency_contact_cell_no: emergencyContactCellNo,
        emergency_contact_address: emergencyContactAddress,
        document_type: documentType,
      };
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(
        `${BASE_URL}/submit_application/submit_basic_info_correction`,
        requestOptions
      );
      const result = await response.json();
      console.log(result);
      if (result.success) {
        toast.success("Application Updated successfully.");
        return true;
      } else {
        toast.error(result.error);
        return false;
      }
    };
  useEffect(() => {
    fetchAllCampaigns();
  }, []);
    useEffect(() => {
      const fetchProvinces = async () => {
        try {
          const response = await fetch(
            `${BASE_URL}/submit_application/get_states`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const data = await response.json();
          if (data && data.states) {
            setProvincesList(data.states);
          }
        } catch (error) {
          console.error("Error fetching provinces:", error);
        }
      };
  
      fetchProvinces();
    }, [BASE_URL, token]);
      useEffect(() => {
        const fetchCities = async () => {
          try {
            const response = await fetch(
              `${BASE_URL}/submit_application/get_cities_by_state/${province}`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
              }
            );
            const data = await response.json();
            if (data && data.cities) {
              setCitiesList(data.cities);
            }
          } catch (error) {
            console.error("Error fetching cities:", error);
          }
        };
    
        if (province) {
          fetchCities();
        }
      }, [province, BASE_URL, token]);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <div className="col-md-3">
                <MDTypography variant="subtitle2" fontWeight="light" mb={1}>
                  Campaigns
                </MDTypography>
                <Select
                  name="campaign_id"
                  options={all_campaigns.map((camp) => ({
                    value: camp.id,
                    label: camp.name,
                  }))}
                  className="basic-single-select"
                  classNamePrefix="select"
                  placeholder="Select Campaign"
                  onChange={handleCampaignChange}
                  value={
                    all_campaigns
                      .map((camp) => ({
                        value: camp.id,
                        label: camp.name,
                      }))
                      .find((option) => option.value === campaignId) || null
                  }
                />
              </div>
              <div className="col-md-3">
                <MDTypography variant="subtitle2" fontWeight="light" mb={1}>
                  Form No
                </MDTypography>
                <MDInput
                  type="text"
                  label="Form No"
                  fullWidth
                  value={form_no}
                  onChange={(e) => setFormNo(e.target.value)}
                />
              </div>
              <div className="col-md-3">
                <MDTypography variant="subtitle2" fontWeight="light" mb={1}>
                  CNIC
                </MDTypography>
                <MDInput
                  type="text"
                  label="CNIC"
                  fullWidth
                  value={applicant_cnic}
                  onChange={(e) => setApplicantCnic(e.target.value)}
                />
              </div>
              <div className="col-md-2">
                <MDBox mt={4}>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ width: "100%", color: "white" }}
                    onClick={fetchApplication}
                  >
                    Fetch Application
                  </Button>
                </MDBox>
              </div>
            </Stack>
          </Grid>
        </Grid>
        <div className="row mt-4">
          <div className="col-md-4">
            <div className="form-outline mt-3">
              <label>
                CNIC
                <span className="text-danger"> *</span>
              </label>
              <InputMask
                mask="99999-9999999-9"
                name="cnic"
                placeholder="CNIC"
                value={cnic}
                onChange={(e) => setCnic(e.target.value)}
                className="form-control form-control-lg"
                required
              />
            </div>
            <div className="error-message1">{formErrors.cnic}</div>
          </div>

          <div className="col-md-4">
            <div className="form-outline mt-3">
              <label>
                Name
                <span className="text-danger"> *</span>
              </label>
              <input
                type="text"
                name="name"
                placeholder="Name"
                pattern="[A-Za-z\s]+"
                value={name}
                onChange={(e) => {
                  const onlyLetters = e.target.value.replace(
                    /[^A-Za-z\s]/g,
                    ""
                  ); // Remove numbers & symbols
                  setName(onlyLetters); // Update state with only letters
                }}
                className="form-control form-control-lg"
                required
              />
            </div>
            <div className="error-message1">{formErrors.name}</div>
          </div>
          <div className="col-md-4">
            <label style={{ marginTop: "17px", marginLeft: "20px" }}>
              Applicant Image<span className="text-danger"> *</span>
            </label>
            <div className="form-outline mt-3">
              <img
                src={applicantImage || "placeholder.jpg"}
                alt="Applicant"
                onClick={() => handlePlaceholderClick("applicantImage")}
                style={{
                  width: "50%",
                  height: "auto",
                  cursor: "pointer",
                  border: "2px dashed #ccc",
                  borderRadius: "8px",
                }}
              />
              <input
                type="file"
                ref={fileInputRefs.applicantImage}
                accept="image/*"
                onChange={(e) => handleImageChange(e, "applicantImage")}
                style={{ display: "none" }}
              />
            </div>
            <div className="error-message1">{formErrors.applicantImage}</div>
          </div>
          <div className="col-md-4">
            <div className="form-outline mt-3">
              <label>
                Document Type
                <span className="text-danger"> *</span>
              </label>
              <select
                name="documentType"
                value={documentType}
                onChange={(e) => setDocumentType(e.target.value)}
                className="form-control form-control-lg"
                required
              >
                <option value="cnic">CNIC</option>
                <option value="bform">B-Form</option>
              </select>
            </div>
            <div className="error-message1">{formErrors.documentType}</div>
          </div>

          <div className="col-md-4">
            <label style={{ marginTop: "17px", marginLeft: "20px" }}>
              {documentType === "cnic"
                ? "Applicant CNIC Front"
                : "Applicant B-Form"}
              <span className="text-danger"> *</span>
            </label>
            <div className="form-outline mt-3">
              <img
                src={applicantCnicFront || "image_picker.png"}
                alt="CNIC Front"
                onClick={() => handlePlaceholderClick("applicantCnicFront")}
                style={{
                  width: "90%",
                  height: "auto",
                  cursor: "pointer",
                  borderRadius: "8px",
                  border: "2px dashed #ccc",
                }}
              />
              <input
                type="file"
                ref={fileInputRefs.applicantCnicFront}
                accept="image/*"
                onChange={(e) => handleImageChange(e, "applicantCnicFront")}
                style={{ display: "none" }}
              />
            </div>
            <div className="error-message1">
              {formErrors.applicantCnicFront}
            </div>
          </div>
          {documentType === "cnic" && (
            <div className="col-md-4">
              <label style={{ marginTop: "17px", marginLeft: "20px" }}>
                Applicant CNIC Back
                <span className="text-danger"> *</span>
              </label>
              <div className="form-outline mt-3">
                <img
                  src={applicantCnicBack || "image_picker.png"}
                  alt="CNIC Back"
                  onClick={() => handlePlaceholderClick("applicantCnicBack")}
                  style={{
                    width: "90%",
                    height: "auto",
                    cursor: "pointer",
                    border: "2px dashed #ccc",
                    borderRadius: "8px",
                  }}
                />
                <input
                  type="file"
                  ref={fileInputRefs.applicantCnicBack}
                  accept="image/*"
                  onChange={(e) => handleImageChange(e, "applicantCnicBack")}
                  style={{ display: "none" }}
                />
              </div>
              <div className="error-message1">
                {formErrors.applicantCnicBack}
              </div>
            </div>
          )}

          <div className="col-md-4">
            <div className="form-outline mt-3">
              <label>
                Date of Birth
                <span className="text-danger"> *</span>
              </label>
              <input
                type="date"
                name="dateOfBirth"
                value={dateOfBirth}
                max={getSixteenYearsBack()}
                onChange={(e) => setDateOfBirth(e.target.value)}
                className="form-control form-control-lg"
                required
              />
            </div>
            <div className="error-message1">{formErrors.dateOfBirth}</div>
          </div>
          <div className="col-md-4">
            <div className="form-outline mt-3">
              <label>
                Father Name
                <span className="text-danger"> *</span>
              </label>
              <input
                type="text"
                name="fatherName"
                placeholder="Father Name"
                value={fatherName}
                onChange={(e) => {
                  const onlyLetters = e.target.value.replace(
                    /[^A-Za-z\s]/g,
                    ""
                  );
                  setFatherName(onlyLetters);
                }}
                className="form-control form-control-lg"
                required
              />
            </div>
            <div className="error-message1">{formErrors.fatherName}</div>
          </div>

          <div className="col-md-4">
            <div className="form-outline mt-3">
              <label>
                Father/Guardian Occupation
                <span className="text-danger"> *</span>
              </label>
              <input
                type="text"
                name="fatherOccupation"
                placeholder="Father/Guardian Occupation"
                value={fatherOccupation}
                onChange={(e) => {
                  const onlyLetters = e.target.value.replace(
                    /[^A-Za-z\s]/g,
                    ""
                  );
                  setFatherOccupation(onlyLetters);
                }}
                className="form-control form-control-lg"
                required
              />
            </div>
            <div className="error-message1">{formErrors.fatherOccupation}</div>
          </div>
          <div className="col-md-4">
            <div className="form-outline mt-3">
              <label>
                Father/Guardian CNIC
                <span className="text-danger"> *</span>
              </label>
              <InputMask
                mask="99999-9999999-9"
                name="fatherCnic"
                placeholder="Father/Guardian CNIC"
                value={fatherCnic}
                onChange={(e) => setFatherCnic(e.target.value)}
                className="form-control form-control-lg"
                required
              />
            </div>
            <div className="error-message1">{formErrors.fatherCnic}</div>
          </div>
          {application_type != "Undergraduate" && (
            <div className="col-md-4">
              <div className="form-outline mt-3">
                <label>BZU Registration</label>
                <input
                  type="text"
                  name="bzuRegistration"
                  placeholder="BZU Registration"
                  value={bzuRegistration}
                  onChange={(e) => setBzuRegistration(e.target.value)}
                  className="form-control form-control-lg"
                  required
                />
              </div>
              <div className="error-message1">{formErrors.bzuRegistration}</div>
            </div>
          )}

          <div className="col-md-4">
            <div className="form-outline mt-3">
              <label>
                Gender
                <span className="text-danger"> *</span>
              </label>
              <select
                name="gender"
                value={gender}
                onChange={(e) => setGender(e.target.value)}
                className="form-control form-control-lg"
                required
              >
                <option value="">Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>
            <div className="error-message1">{formErrors.gender}</div>
          </div>
          <div className="col-md-4">
            <div className="form-outline mt-3">
              <label>
                Nationality
                <span className="text-danger"> *</span>
              </label>
              <select
                name="nationality"
                value={nationality}
                onChange={(e) => setNationality(e.target.value)}
                className="form-control form-control-lg"
                required
              >
                <option value="">Select Nationality</option>
                <option value="Pakistani">Pakistani</option>
                <option value="Overseas">Overseas</option>
                <option value="Other">Other</option>
              </select>
            </div>
            <div className="error-message1">{formErrors.nationality}</div>
          </div>

          <div className="col-md-4">
            <div className="form-outline mt-3">
              <label>
                Province
                <span className="text-danger"> *</span>
              </label>
              <select
                name="province"
                value={province}
                onChange={(e) => setProvince(e.target.value)}
                className="form-control form-control-lg"
                required
              >
                <option value="">Select Province</option>
                {provincesList.map((prov) => (
                  <option key={prov.id} value={prov.name}>
                    {prov.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="error-message1">{formErrors.province}</div>
          </div>
          <div className="col-md-4">
            <div className="form-outline mt-3">
              <label>
                Domicile
                <span className="text-danger"> *</span>
              </label>
              <select
                name="domicile"
                value={domicile}
                onChange={(e) => setDomicile(e.target.value)}
                className="form-control form-control-lg"
                required
              >
                <option value="">Select Domicile</option>
                {citiesList.map((city) => (
                  <option key={city.id} value={city.name}>
                    {city.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="error-message1">{formErrors.domicile}</div>
          </div>

          <div className="col-md-4">
            <div className="form-outline mt-3">
              <label>
                Religion
                <span className="text-danger"> *</span>
              </label>
              <select
                name="religion"
                value={religion}
                onChange={(e) => setReligion(e.target.value)}
                className="form-control form-control-lg"
                required
              >
                <option value="">Select Religion</option>
                <option value="Muslim">Muslim</option>
                <option value="Non-Muslim">Non-Muslim</option>
              </select>
            </div>
            <div className="error-message1">{formErrors.religion}</div>
          </div>

          <div className="col-md-4">
            <div className="form-outline mt-3">
              <label>
                Current Address
                <span className="text-danger"> *</span>
              </label>
              <input
                type="text"
                name="currentAddress"
                placeholder="Current Address"
                value={currentAddress}
                onChange={(e) => setCurrentAddress(e.target.value)}
                className="form-control form-control-lg"
                required
              />
            </div>
            <div className="error-message1">{formErrors.currentAddress}</div>
          </div>

          <div className="col-md-4">
            <div className="form-outline mt-3">
              <label>
                Permanent Address
                <span className="text-danger"> *</span>
              </label>
              <input
                type="text"
                name="permanentAddress"
                placeholder="Permanent Address"
                value={permanentAddress}
                onChange={(e) => setPermanentAddress(e.target.value)}
                className="form-control form-control-lg"
                required
              />
            </div>
            <div className="error-message1">{formErrors.permanentAddress}</div>
          </div>

          <div className="col-md-4">
            <div className="form-outline mt-3">
              <label>Telephone Number</label>
              <InputMask
                mask="(999) 999-9999"
                name="telNo"
                placeholder="(123) 456-7890"
                value={telNo}
                onChange={(e) => setTelNo(e.target.value)}
                className="form-control form-control-lg"
                required
              />
            </div>
            <div className="error-message1">{formErrors.telNo}</div>
          </div>

          <div className="col-md-4">
            <div className="form-outline mt-3">
              <label>
                Father/Guardian Cell Number
                <span className="text-danger"> *</span>
              </label>
              <InputMask
                mask="9999-9999999"
                name="fatherCellNo"
                placeholder="Father/Guardian Cell Number"
                value={fatherCellNo}
                onChange={(e) => setFatherCellNo(e.target.value)}
                className="form-control form-control-lg"
                required
              />
            </div>
            <div className="error-message1">{formErrors.fatherCellNo}</div>
          </div>

          <div className="col-md-4">
            <div className="form-outline mt-3">
              <label>
                Applicant Cell Number
                <span className="text-danger"> *</span>
              </label>
              <InputMask
                mask="9999-9999999"
                name="applicantCellNo"
                placeholder="Applicants Cell Number"
                value={applicantCellNo}
                onChange={(e) => setApplicantCellNo(e.target.value)}
                className="form-control form-control-lg"
                required
              />
            </div>
            <div className="error-message1">{formErrors.applicantCellNo}</div>
          </div>

          <div className="col-md-4">
            <div className="form-outline mt-3">
              <label>
                Place of Stay
                <span className="text-danger"> *</span>
              </label>
              <select
                name="placeOfStay"
                value={placeOfStay}
                onChange={(e) => setPlaceOfStay(e.target.value)}
                className="form-control form-control-lg"
                required
              >
                <option value="">Select Place of Stay</option>
                <option value="Own Hostel">Own Hostel</option>
                <option value="University Hostel">University Hostel</option>
                <option value="Own House">Own House</option>
              </select>
            </div>
            <div className="error-message1">{formErrors.placeOfStay}</div>
          </div>

          <div className="col-md-4">
            <div className="form-outline mt-3">
              <label>
                Hafiz e Quran
                <span className="text-danger"> *</span>
              </label>
              <select
                name="hafizQuran"
                value={hafizQuran}
                onChange={(e) => setHafizQuran(e.target.value)}
                className="form-control form-control-lg"
                required
              >
                <option value="">Select Hafiz e Quran</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
            <div className="error-message1">{formErrors.hafizQuran}</div>
          </div>
          <div className="col-md-4">
            <div className="form-outline mt-3">
              <label>Are you disabled?</label>
              <div className="d-flex gap-3">
                <label>
                  <input
                    type="radio"
                    name="disabled"
                    value="yes"
                    checked={isDisabled === "yes"}
                    onChange={() => setIsDisabled("yes")}
                  />{" "}
                  Yes
                </label>
                <label>
                  <input
                    type="radio"
                    name="disabled"
                    value="no"
                    checked={isDisabled === "no"}
                    onChange={() => setIsDisabled("no")}
                  />{" "}
                  No
                </label>
              </div>
            </div>
          </div>

          {isDisabled === "yes" && (
            <div className="col-md-4">
              <div className="form-outline mt-3">
                <label>Enter Your Disability</label>
                <input
                  type="text"
                  name="disability"
                  placeholder="Disability"
                  value={disability}
                  onChange={(e) => setDisability(e.target.value)}
                  className="form-control form-control-lg"
                />
              </div>
            </div>
          )}
          <div className="col-md-12 mt-3 mb-3">
            <Typography variant="h4">Emergency Contact Information</Typography>
          </div>
          <div className="col-md-4">
            <div className="form-outline mt-3">
              <label>
                Emergency Contact Name
                <span className="text-danger"> *</span>
              </label>
              <input
                type="text"
                name="emergencyContactName"
                placeholder="Emergency Contact Name"
                value={emergencyContactName}
                onChange={(e) => {
                  const onlyLetters = e.target.value.replace(
                    /[^A-Za-z\s]/g,
                    ""
                  );
                  setEmergencyContactName(onlyLetters);
                }}
                className="form-control form-control-lg"
                required
              />
            </div>
            <div className="error-message1">
              {formErrors.emergencyContactName}
            </div>
          </div>

          <div className="col-md-4">
            <div className="form-outline mt-3">
              <label>
                Emergency Contact Cell Number
                <span className="text-danger"> *</span>
              </label>
              <InputMask
                mask="9999-9999999"
                name="emergencyContactCellNo"
                placeholder="Emergency Contact Cell Number"
                value={emergencyContactCellNo}
                onChange={(e) => setEmergencyContactCellNo(e.target.value)}
                className="form-control form-control-lg"
                required
              />
            </div>
            <div className="error-message1">
              {formErrors.emergencyContactCellNo}
            </div>
          </div>

          <div className="col-md-4">
            <div className="form-outline mt-3">
              <label>
                Emergency Contact Address
                <span className="text-danger"> *</span>
              </label>
              <input
                type="text"
                name="emergencyContactAddress"
                placeholder="Emergency Contact Address"
                value={emergencyContactAddress}
                onChange={(e) => setEmergencyContactAddress(e.target.value)}
                className="form-control form-control-lg"
                required
              />
            </div>
            <div className="error-message1">
              {formErrors.emergencyContactAddress}
            </div>
          </div>

          <div className="col-md-10 mt-3">
          </div>
          <div className="col-md-2 mt-3">
            <Button
              variant="contained"
              color="primary"
              style={{ width: "100%",color:"white" }}
              onClick={submitStep1}
            >
              Submit
            </Button>
          </div>
        </div>
      </MDBox>
      {/* Cropper Dialog */}
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Crop Image</DialogTitle>
        <DialogContent>
          <Cropper
            src={tempImage}
            style={{ height: 400, width: "100%" }}
            aspectRatio={currentField === "applicantImage" ? 1 : NaN} // Fixed ratio for applicantImage
            guides={true}
            onInitialized={(cropperInstance) => setCropper(cropperInstance)} // Corrected instance usage
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenDialog(false)}
            className="dialog-actions-button negative"
          >
            Cancel
          </Button>
          <Button
            onClick={cropImage}
            className="dialog-actions-button positive"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
};

export default BasicInfoCorrection;
